import { CycleDetailPage } from '@/components/billing/cycle-detail-page'

export function CommitteeBillingCycleDetail() {
  return <CycleDetailPage basePath="/committee/billing" />
}
